<template>
    <div class="ProfileBox">
        <h2>{{ this.risorse["DatiUtente"] }}</h2>
        <div class="Form">
            <div class="FormRow">
                <div class="FormBoxWide">
                    <div class="UserInfo"><span>{{ this.risorse["Nome"] }}</span> <span>{{ this.$store.getters.getNome}}</span></div>
                </div>
            </div>
            <div class="FormRow">
                <div class="FormBoxWide">
                    <div class="UserInfo"><span>{{ this.risorse["Cognome"] }}</span> <span> {{ this.$store.getters.getCognome}}</span></div>
                </div>
            </div>
            <div class="FormRow">
                <div class="FormBoxWide">
                    <div class="UserInfo"><span>{{ this.risorse["Email"] }}</span> <span>{{ this.emailUtente }}</span></div>
                </div>
            </div>
            <div class="FormRow">
                <div class="FormBoxWide">
                    <div class="UserInfo"><span>{{ this.risorse["Azienda"] }}</span> <span>{{ this.$store.getters.getAzienda.Anagrafica.RagioneSociale}}</span></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {risorseMixin} from "@/mixin.js";
import AnagraficaService from "@/services/anagrafica.service.js";

export default {
    name: "DatiUtente",
    mixins:[risorseMixin],
    data(){
        return {
            emailUtente: ""
        }
    },
    mounted(){
        AnagraficaService.getEmailUtente(this.$store.getters.getToken).then(
            data => {
                if(!data){
                    this.$router.push("/");
                }
                else{
                    this.emailUtente = data.Email;
                }
            }
        );
    }
}
</script>